import { render, staticRenderFns } from "./questionPool.vue?vue&type=template&id=2cb027ca&scoped=true&"
import script from "./questionPool.vue?vue&type=script&lang=js&"
export * from "./questionPool.vue?vue&type=script&lang=js&"
import style0 from "./questionPool.vue?vue&type=style&index=0&id=2cb027ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb027ca",
  null
  
)

export default component.exports